import { Box } from "@mui/material";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { verifyUserAPI } from "@src/api/auth";
import Failed from "./failed";
import Success from "./success";

let verificationPromise: Promise<void> | null = null;

function getVerificationPromise(userId: string, code: string) {
  if (!verificationPromise) {
    verificationPromise = new Promise<void>((resolve, reject) =>
      setTimeout(() => verifyUserAPI({ userId, code }).then(resolve).catch(reject), 1000 * 3)
    );
  }
  return verificationPromise;
}

export default function AccountVerification() {
  const [searchParams] = useSearchParams();
  const idValue = searchParams.get('userId');
  const codeValue = searchParams.get('code');
  const [status, setStatus] = useState<'pending' | 'success' | 'error'>('pending');

  useEffect(() => {
    if (!idValue || !codeValue) return;
    getVerificationPromise(idValue, codeValue)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderContent = () => {
    if (status === 'error') {
      return <Failed />
    }

    if (status === 'success') {
      return <Success />
    }

    return (
      <h1>Verifying account...</h1>
    );
  }

  return (
    <Box
      flex={1}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#ffffff'
      }}
    >
      {renderContent()}
    </Box>
  )
}